export function setDatePickerMargin() {
  var pickerParent = document.getElementsByClassName("input-group")[0];
  if (pickerParent) {
    pickerParent.childNodes[2].onclick = function() {
      var current = this;
      var offset = 0;
      while (current !== null) {
        offset += current.offsetTop;
        current = current.offsetParent;
      }
      if (window.innerHeight - offset + window.scrollY < 300) {
        this.parentElement.parentElement.parentElement.className = "picker-top";
      } else {
        this.parentElement.parentElement.parentElement.className =
          "picker-bottom";
      }
    };
  }
}
